import styled from 'styled-components';
import { variant } from 'styled-system';
import themeUtilities from '../../../theme/ThemeUtilities';
import { Size } from './types';

export const StyledTable = styled.table<{ size?: Size }>`
  width: 100%;
  box-sizing: border-box;
  border-spacing: 0;
  overflow-x: scroll;
  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'Table', 'table'))};
`;
StyledTable.defaultProps = {
  size: 'regular',
};
export const TableWrapper = styled.div<{ wrapper?: 'default' }>`
  overflow-x: hidden;
  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'Table', 'wrapper'))};
`;
TableWrapper.defaultProps = {
  wrapper: 'default',
};
export const ScrollWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;
